<template>
  <b-nav-item
    @click.prevent="gotoDSDashBoard"
    v-b-tooltip.hover="'Service Session Worklist'"
  >
    <b-icon-card-list variant="light" class="menu-icon" />
  </b-nav-item>
</template>

<script>
//---- mixins -------------
import QuestMenuMixins from "@/app/components/callcenter/app-header/QuestMenuMixins"
//---- 3rd-parties --------
import { BIconCardList } from "bootstrap-vue";
export default {
  mixins:[QuestMenuMixins],
  components: {
    BIconCardList,
  } ,
};
</script>